















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import { IProducerCommissionInput } from '@/modules/Producer/interfaces/producer-form'

@Component({
  components: {
    AppTextField
  }
})
export default class ProducerFormCommission extends Vue {
  @Prop({ type: Object as () => IProducerCommissionInput }) value!: IProducerCommissionInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
